import { MytimesheetComponent } from './view/mytimesheet/mytimesheet.component';
import { DownloadExportComponent } from './view/download-export/download-export.component';
import { HomeComponent } from './view/home/home.component';
import { PageNotFoundComponent } from './view/page-not-found/page-not-found.component';
import { TimesheetComponent } from './view/timesheet/timesheet.component';
import { TrainingComponent } from './view/training/training.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import {BadrequestComponent} from './view/badrequest/badrequest.component';
import {environment} from '../environments/environment';
import {TraitementmasseComponent} from './view/traitementmasse/traitementmasse.component';
import {ReclamationViewComponent} from './view/reclamation-view/reclamation-view.component';
import { CanActivateCoach } from './guard/coach-guard.service';
import {TraitementIncoComponent} from './view/traitement-inco/traitement-inco.component';
import {ValidationVerroComponent} from './view/validationVerro/validationVerro.component';
import {SearchtimesheetComponent} from './view/searchtimesheet/searchtimesheet.component';
import {FaqComponent} from './view/faq/faq.component';
import { IS_PORTUGAL } from './helpers/GlobalConstants';
import { ReopenRequestsProcessComponent } from './view/reopen-requests-process/reopen-requests-process.component';
import { ReopenRequestsSuiviComponent } from './view/reopen-requests-suivi/reopen-requests-suivi.component';
import {DashboardComponent} from './view/bi/dashboard/dashboard.component';
import { ReopenRequestsHistoryComponent } from './view/reopen-requests-history/reopen-requests-history.component';
import {InjectionComponent} from './view/injection/injection.component';
import {Route} from "@angular/router";
import {UnlockRequestsHistoryComponent} from './view/unlock-requests-history/unlock-requests-history.component';
import {UnlockRequestsSuiviComponent} from './view/unlock-requests-suivi/unlock-requests-suivi.component';
import {UnlockRequestsProcessComponent} from './view/unlock-requests-process/unlock-requests-process.component';

export let isConnected  = localStorage.getItem(environment.oauth.remoteUser) !== null;
export let isPorgugal  = localStorage.getItem(IS_PORTUGAL) == 'Y';
export const portugalMenus = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'validation-verro',
    component: ValidationVerroComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'traitement',
    component: TraitementmasseComponent,
  },
  {
    path: 'traitementinco',
    component: TraitementIncoComponent,
  },{
    path: 'searchtimesheet',
    component: SearchtimesheetComponent,
    children: [
      {
        path: ':username/:date',
        component: SearchtimesheetComponent,
      }
    ]
  },
  {
    path: 'mytimesheet',
    component: MytimesheetComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        except: ['ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2_CLIENT', 'ROLE_DIRECTOR_MYSHIFT2', 'ROLE_DIRECTEUR_PAYS_MYSHIFT2', 'ROLE_RH_MYSHIFT2',
      ],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'timesheet',
    component: TimesheetComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2',
              'ROLE_SUPER_USER_MYSHIFT2',
              'ROLE_MANAGER_MYSHIFT2',
              'ROLE_DIRECTOR_MYSHIFT2',
              'ROLE_DIRECTEUR_PAYS_MYSHIFT2',
              'ROLE_RH_MYSHIFT2',
              'MYSHIFT2_STANDARD_ROLE'
            ],
        redirectTo: '/'
      },
      origin: 'timesheet'
      },
    children: [
      {
        path: ':username/:date',
        component: TimesheetComponent,
      }
    ]
  },
  // {
  //   path: 'export',
  //   component: DownloadExportComponent,
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: ['ROLE_COORDI_FORMATION_MYSHIFT2', 'ROLE_ADMIN_MYSHIFT2', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTEUR_PAYS_MYSHIFT2',
  //         'ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_RH_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2', 'ROLE_FORMATEUR_MYSHIFT2'],
  //       redirectTo: '/'
  //     }
  //   }
  // },
  {
    path: 'training',
    component: TrainingComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2', 'ROLE_FORMATEUR_MYSHIFT2', 'ROLE_COORDI_FORMATION_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-reopen-requests',
    component: ReopenRequestsProcessComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['REOUVERTURE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        // only: ['ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  }, {
    path: 'process-reopen-history',
    component: ReopenRequestsHistoryComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['REOUVERTURE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        // only: ['ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  }, {
    path: 'process-reopen-suivi',
    component: ReopenRequestsSuiviComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  }, {
    path: 'coaching',
    component: TimesheetComponent,
    canActivate: [NgxPermissionsGuard, CanActivateCoach],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2', 'ROLE_SUPER_USER_MYSHIFT2',
              'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      },
      origin: 'coaching'
    }
  },
  {
    path: 'reclamation',
    component: ReclamationViewComponent
  },
  {
    path: 'badrequest',
    component: BadrequestComponent
  },
  {
    path: 'security',
    component: BadrequestComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: '**',
    component: HomeComponent
  }

]
export const Routes: Route[] = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'validation-verro',
    component: ValidationVerroComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'traitement',
    component: TraitementmasseComponent,
  },
  {
    path: 'traitementinco',
    component: TraitementIncoComponent,
  },{
    path: 'searchtimesheet',
    component: SearchtimesheetComponent
  },
  {
    path: 'process-reopen-requests',
    component: ReopenRequestsProcessComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['REOUVERTURE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-unlock-requests',
    component: UnlockRequestsProcessComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['DEVEROUILLAGE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-reopen-history',
    component: ReopenRequestsHistoryComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['REOUVERTURE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-unlock-history',
    component: UnlockRequestsHistoryComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['DEVEROUILLAGE', 'ROLE_DIRECTOR_MYSHIFT2_CLIENT','MYSHIFT2_HRBP_ROLE'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-reopen-suivi',
    component: ReopenRequestsSuiviComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['REOUVERTURE', 'ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'process-unlock-suivi',
    component: UnlockRequestsSuiviComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['DEVEROUILLAGE', 'ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'mytimesheet',
    component: MytimesheetComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        except: ['ROLE_COORDINATOR', 'ROLE_MANAGER_MYSHIFT2_CLIENT', 'ROLE_DIRECTOR_MYSHIFT2', 'ROLE_DIRECTEUR_PAYS_MYSHIFT2', 'ROLE_RH_MYSHIFT2',
      ],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'injection',
    component: InjectionComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_COORDINATOR'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'timesheet',
    component: TimesheetComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2',
              'ROLE_SUPER_USER_MYSHIFT2',
              'ROLE_MANAGER_MYSHIFT2',
              'ROLE_DIRECTOR_MYSHIFT2',
              'ROLE_DIRECTEUR_PAYS_MYSHIFT2',
              'ROLE_RH_MYSHIFT2',
              'MYSHIFT2_STANDARD_ROLE'
            ],
        redirectTo: '/'
      },
      origin: 'timesheet'
      },
    children: [
      {
        path: ':username/:date',
        component: TimesheetComponent,
      }
    ]
  },
  // {
  //   path: 'export',
  //   component: DownloadExportComponent,
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: ['ROLE_COORDI_FORMATION_MYSHIFT2', 'ROLE_ADMIN_MYSHIFT2', 'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTEUR_PAYS_MYSHIFT2',
  //         'ROLE_TL_MYSHIFT2', 'ROLE_COORDINATEUR_MYSHIFT2', 'ROLE_RH_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2', 'ROLE_FORMATEUR_MYSHIFT2'],
  //       redirectTo: '/'
  //     }
  //   }
  // },
  {
    path: 'training',
    component: TrainingComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2', 'ROLE_FORMATEUR_MYSHIFT2', 'ROLE_COORDI_FORMATION_MYSHIFT2'],
        redirectTo: '/'
      }
    }
  },
  {
    path: 'coaching',
    component: TimesheetComponent,
    canActivate: [NgxPermissionsGuard, CanActivateCoach],
    data: {
      permissions: {
        only: ['ROLE_ADMIN_MYSHIFT2', 'ROLE_SUPER_USER_MYSHIFT2',
              'ROLE_MANAGER_MYSHIFT2', 'ROLE_DIRECTOR_MYSHIFT2'],
        redirectTo: '/'
      },
      origin: 'coaching'
    }
  },
  {
    path: 'reclamation',
    component: ReclamationViewComponent
  },
  {
    path: 'badrequest',
    component: BadrequestComponent
  },
  {
    path: 'security',
    component: BadrequestComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'dashboard/:type',
    component: DashboardComponent
  },
  {
    path: '**',
    component: HomeComponent
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts